import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import styled from "styled-components";
import FormResetPassword from "./FormResetPassword";

import Service from '../../service/Auth'
import LoadingContent from '../../component/loading/LoadingContent'
import actions from "../../redux/actions";

const Section = styled.div`
    .form-container {
        margin-right: auto;
        margin-left: auto;

        @media only screen and (max-width: 768px) {
            width: 50%;
        }
        @media only screen and (max-width: 450px) {
            width: 80%;    
        }
        @media only screen and (max-width: 376px) {
            width: 100%;    
        }

        @media only screen and (min-width: 1200px) {
            width: 40%;
        }

    }

`


export default function Index(props) {
    
    const [content, setContent] = useState(false)
    const { token } = useParams()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(actions.master.setPath(""))
        const init = async() =>{
            console.log(token)
            let result = await Service.forgetPwdVerifyToken(token)
            console.log(result)
        }

        init()
        setContent(true)
    }, [token, dispatch])

    return(
        <Section className={"section-reset-password" + (props.className ? props.className : "")}>
            <div className="container">
            {!content ? <LoadingContent/>
            :
            <>
                <div className="section-heading">
                    รีเซ็ทรหัสผ่าน
                </div>
                <div className="form-container">
                    <FormResetPassword token={token}/>
                </div>
                </>
            }
            </div>
        </Section>
    )
}